
	export const fuel_price =150;
	export const fuel_quantity =1;
	export const gas_price =350;
	export const gas_quantity =1;
	export const diesel_price =200;
	export const diesel_quantity =1; 
